import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-shared-accordion',
  templateUrl: './shared-accordion.component.html',
  styleUrls: ['./shared-accordion.component.scss']
})
export class SharedAccordionComponent implements OnInit {
  @Input() header: string = 'Accordion Header';
  @Input() content: string = 'Accordion Content';
  @Input() translate: boolean = false;

  public viewAccordion: boolean = false;

  toggleAccordion() {
    this.viewAccordion = !this.viewAccordion;
  }

  constructor() { }

  ngOnInit() {
  }

}
